import { render, staticRenderFns } from "./PaymentTeaser.vue?vue&type=template&id=961f9720&scoped=true&"
import script from "./PaymentTeaser.vue?vue&type=script&lang=js&"
export * from "./PaymentTeaser.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTeaser.vue?vue&type=style&index=0&id=961f9720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961f9720",
  null
  
)

export default component.exports